import { useState } from 'react'

import LastPageIcon from '@mui/icons-material/LastPage'
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess'
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import Tooltip from '@mui/material/Tooltip'

import { EventCard } from '@components/EventCard'
import type { Event } from '@models/Event'
import type { Gebied } from '@models/Gebied'
import { eventTypeTitle, extractEventTypes } from '@util/event-util'

import { SelectString } from '../../../core/components/SelectString'

interface Props {
  log: Event[]
  onClose: () => void
  open: boolean
  gebieden: Gebied[]
}

export const Log = ({ log, onClose, open, gebieden }: Props) => {
  const [showTypes, setShowTypes] = useState<Event['type'][]>([])
  const [expandAll, setExpandAll] = useState(true)
  const events = log.filter((event) => event.type !== 'product-annulering')
  const availableTypesArr = extractEventTypes(events)

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      data-testid="project-log-drawer"
    >
      <Box
        sx={{
          p: 2,
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            width: '500px',
          }}
        >
          <Grid
            size={{ xs: 12 }}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'end',
            }}
          >
            <IconButton
              data-testid="close-button"
              onClick={onClose}
              sx={{ color: 'black' }}
            >
              <LastPageIcon />
            </IconButton>

            <ToggleButtonGroup
              value={expandAll}
              exclusive
              onChange={(_, bool) => setExpandAll(bool)}
            >
              <Tooltip title="Alles uitvouwen">
                <ToggleButton
                  value={true}
                  selected={expandAll}
                  data-testid="expand-all-button"
                >
                  <UnfoldMoreIcon />
                </ToggleButton>
              </Tooltip>

              <Tooltip title="Alles inklappen">
                <ToggleButton
                  value={false}
                  selected={!expandAll}
                  data-testid="collapse-all-button"
                >
                  <UnfoldLessIcon />
                </ToggleButton>
              </Tooltip>
            </ToggleButtonGroup>
          </Grid>

          <Grid size={{ xs: 12 }}>
            <SelectString
              multiple
              options={availableTypesArr}
              getOptionLabel={(option) => eventTypeTitle[option]}
              onChange={(types) => {
                /* v8 ignore next - TODO: missing coverage -- @preserve */
                if (!types?.length) {
                  setExpandAll(true)
                }

                /* v8 ignore next - TODO: missing coverage -- @preserve */
                setShowTypes(types || [])
              }}
              value={showTypes}
              label="Type"
            />
          </Grid>

          {events.length > 0 && (
            <Grid size={{ xs: 12 }}>
              {events
                .filter((event) => {
                  return showTypes.length === 0
                    ? true
                    : showTypes.includes(event.type)
                })
                .map((event) => (
                  <EventCard
                    key={event._id}
                    event={event}
                    open={expandAll}
                    gebieden={gebieden}
                  />
                ))}
            </Grid>
          )}
        </Grid>
      </Box>
    </Drawer>
  )
}
